export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The learning objective was clear to me.",
			},
			{
				id: 2,
				text: "The educational objectives were well defined from the beginning.",
			},
			{
				id: 3,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 4,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 5,
				text: "I was already interested in the subject of the course before I signed up for it.",
			},
			{
				id: 6,
				text: "I believe that I have learned important facts in this course.",
			},
			{
				id: 7,
				text: "The topic of the course is relevant.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 8,
				text: "The difficulty of the content was...",
			},
			{
				id: 9,
				text: "The amount of the content was...",
			},
			{
				id: 10,
				text: "The requirements of the course were...",
			},
			{
				id: 11,
				text: "The amount of time required for the course (including preparation and follow-up) was...",
			},
			{
				id: 12,
				text: "Overall, I felt the course to be...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 13,
				text: "Concerning the organizational aspects of the course (i.e. place, time, performance requirements) I was informed well",
			},
			{
				id: 14,
				text: "Organizational issues were dealt with in time and in detail.",
			},
			{
				id: 15,
				text: "The course was running smoothly during the semester.",
			},
			{
				id: 16,
				text: "Altogether, the course was well organized.",
			},
			{
				id: 17,
				text: "Overall, this was a good course.",
			},
			{
				id: 18,
				text: "I learned a lot in this course.",
			},
			{
				id: 19,
				text: "The course fulfilled my expectations.",
			},
			{
				id: 20,
				text: "I would recommend the course.",
			},
			{
				id: 21,
				text: "In terms of its quality, this course was as good as the best course I have ever attended.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 22,
				text: "Further remarks: I especially liked (lecture)",
			},
			{
				id: 23,
				text: "Further remarks: I did not like (lecture)",
			},
			{
				id: 24,
				text: "Further remarks: Suggestions for improvements (lecture)",
			},
			{
				id: 25,
				text: "Further remarks: I especially liked (self-study phase)",
			},
			{
				id: 26,
				text: "Further remarks: I did not like (self-study phase)",
			},
			{
				id: 27,
				text: "Further remarks: Suggestions for improvements (self-study phase)",
			},
		],
	},
	{
		type: "text",
		id: 5,
		title: "Evaluation of the tutorial",
		items: [
			{
				id: 28,
				type: "medium",
				text: "Name of the tutor",
			},
		],
	},
	{
		type: "uni",
		id: 6,
		items: [
			{
				id: 29,
				text: "Overall, the office hours (if offered) are very helpful.",
			},
			{
				id: 30,
				text: "The exercises increased my knowledge on the topic.",
			},
			{
				id: 31,
				text: "I consider the general format of the tutorial to be appropriate (i.e. compulsory attendance, exercise during course, sample solution, modeling calculations).",
			},
			{
				id: 32,
				text: "My tutor has always been well prepared.",
			},
			{
				id: 33,
				text: "My tutor was able to put complicated ideas across.",
			},
			{
				id: 34,
				text: "My tutor was able to impart background knowledge of the content.",
			},
			{
				id: 35,
				text: "My tutor did a good job within the possibilities provided by the lecturer.",
			},
			{
				id: 36,
				text: "The difficulty of the exercises/projects was too high.",
			},
			{
				id: 37,
				text: "The topics have been illustrated during the tutorial by using examples.",
			},
			{
				id: 38,
				text: "During the tutorial a relation between theory and praxis/implementation is developed.",
			},
		],
	},
	{
		type: "text",
		id: 7,
		items: [
			{
				id: 39,
				text: "Further remarks: I especially liked (tutorial)",
			},
			{
				id: 40,
				text: "Further remarks: I did not like (tutorial)",
			},
			{
				id: 41,
				text: "Further remarks: Suggestions for improvements (tutorial)",
			},
		],
	},
];
